import { useContext, useMemo } from 'react';
import { Loader } from '../Common/Loader';
import { CheckoutContext } from '@/context/CheckoutContext';
import { PaymentMethodEnum } from '@/types/common';
import { PaymentMethodsToShowLoaderWhileProcessing } from '@/constants/FormByPayment';
import { shouldShowLoader } from '@/utils/conditionalRendering';

export const ProcessingLoader = () => {
  const {
    payment: { isInPaymentProcess, isExpressPaymentInProcess },
    paymentMethodSelected,
    otherMethodSelected,
    featureFlags,
  } = useContext(CheckoutContext);

  const selectedMethod = useMemo(() => {
    return paymentMethodSelected === PaymentMethodEnum.OTHER ? otherMethodSelected : paymentMethodSelected;
  }, [paymentMethodSelected, otherMethodSelected]);

  if (!shouldShowLoader(featureFlags)) {
    return null;
  }

  if (
    (isInPaymentProcess && PaymentMethodsToShowLoaderWhileProcessing.includes(selectedMethod as PaymentMethodEnum)) ||
    isExpressPaymentInProcess
  ) {
    return (
      <div
        data-testid="processing-loader"
        className="fixed inset-0 bg-base-black/50 flex items-center justify-center z-150"
      >
        <Loader />
      </div>
    );
  }
  return null;
};
